import Api from '@/services/Api'

export default {
  index (params) {
    return Api().post('careGroup', params)
  },
  create (params) {
    return Api().post('careGroupNew', params)
  },
  show (params) {
    return Api().post('careGroupEdit', params)
  },
  state (params) {
    return Api().post('careGroupState', params)
  }
}



// WEBPACK FOOTER //
// ./src/services/CareGroupService.js